// Карго enum-уудын frontend metadata (backend int value-тэй тааруулсан).

export const SHIPMENT_STATUS: Record<number, string> = {
  0: 'Бүртгэгдсэн',
  1: 'Агуулахад хүлээн авсан',
  2: 'Замд яваа',
  3: 'Дотоодод ирсэн',
  4: 'Очиж авахад бэлэн',
  5: 'Хүргэлтэд гарсан',
  6: 'Хүргэгдсэн',
  7: 'Буцаагдсан',
  8: 'Цуцлагдсан',
  9: 'Гээгдсэн',
};

export const SHIPMENT_STATUS_COLOR: Record<number, string> = {
  0: 'var(--ts-muted)',
  1: 'var(--ts-info)',
  2: 'var(--ts-high)',
  3: 'var(--ts-accent)',
  4: 'var(--ts-warn)',
  5: 'var(--ts-high)',
  6: 'var(--ts-ok)',
  7: 'var(--ts-critical)',
  8: 'var(--ts-muted)',
  9: 'var(--ts-critical)',
};

export const TRANSPORT_MODE: Record<number, string> = {
  0: 'Агаар',
  1: 'Авто',
  2: 'Төмөр зам',
  3: 'Усан',
};

export const WAREHOUSE_TYPE: Record<number, string> = {
  0: 'Гадаад агуулах',
  1: 'Дотоод агуулах',
  2: 'Очиж авах салбар',
};

export const CONSOLIDATION_STATUS: Record<number, string> = {
  0: 'Нээлттэй',
  1: 'Битүүмжилсэн',
  2: 'Гарсан',
  3: 'Ирсэн',
  4: 'Задалсан',
};

export const DELIVERY_STATUS: Record<number, string> = {
  0: 'Ноорог',
  1: 'Хуваарилсан',
  2: 'Хүргэлтэд гарсан',
  3: 'Хүргэгдсэн',
  4: 'Амжилтгүй',
  5: 'Цуцлагдсан',
};

export const DELIVERY_METHOD: Record<number, string> = {
  0: 'Очиж авах',
  1: 'Хүргэлт',
};

export const PAYMENT_STATUS: Record<number, string> = {
  0: 'Төлөгдөөгүй',
  1: 'Хэсэгчилсэн',
  2: 'Төлөгдсөн',
};

export const PAYMENT_STATUS_COLOR: Record<number, string> = {
  0: 'var(--ts-critical)',
  1: 'var(--ts-warn)',
  2: 'var(--ts-ok)',
};

export const CHARGE_BASIS: Record<number, string> = {
  0: 'Жин',
  1: 'Эзлэхүүн',
  2: 'Тогтмол',
};

export function toOptions(map: Record<number, string>) {
  return Object.entries(map).map(([k, v]) => ({ value: Number(k), label: v }));
}

// Scan станцад түргэн ашиглах статусын товчнууд.
export const SCAN_ACTIONS = [
  { status: 1, label: 'Агуулахад хүлээн авсан', icon: 'bi-box-arrow-in-down' },
  { status: 3, label: 'Дотоодод ирсэн', icon: 'bi-geo-alt' },
  { status: 4, label: 'Очиж авахад бэлэн', icon: 'bi-bell' },
  { status: 5, label: 'Хүргэлтэд гарсан', icon: 'bi-truck' },
  { status: 6, label: 'Хүргэгдсэн', icon: 'bi-check2-circle' },
];
